import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/styles';
import StepHeader from './StepHeader';

export function CustomSectionHeader(props) {
    const { title, subtitle, stepsControl, virtualStep } = props;
    const { palette } = useTheme();
    return (
        <Grid xs={12} item container justifyContent='center'>
            <Grid xs={12} item>
                <StepHeader
                    title={title}
                    palette={palette}
                    onBack={() => stepsControl.goToStepByName(virtualStep)}
                />
                <Grid xs={12} item container justifyContent='center' marginTop={1}>
                    <Typography >{subtitle}</Typography>
                </Grid>
            </Grid>
        </Grid>
    )
}
